/** @jsx h */
import { Fragment, h, VNode } from 'preact';
import { useCallback, useEffect, useMemo, useState } from 'preact/hooks';
import { useTimer } from '../../hooks';
import { AssistButton, AssistButtonAction } from '../../types';
import { getTimeTranslation } from '../../utils';
import Spinner from '../Spinner';
import './style.scss';

type Props = {
  style?: h.JSX.CSSProperties;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  lang?: string;
  children?: VNode;
  onClick?: (action?: AssistButtonAction) => void;
  data: AssistButton;
  isWidgetButton?: boolean;
};

const buttonClassNamesByType = {
  main_default: 'button_main_default btn-border-none',
  main_timer: 'button_main_timer btn-border-none',
  main_dot: 'button_main_dot',
  submit: 'button_submit',
  blue: 'button_blue',
  white: 'button_white btn-border btn-border-gray',
  red: 'button_red btn-border btn-border-gray',
};

function Button({ onClick, className = '', data, loading, isWidgetButton, lang }: Props) {
  const [timerHasStarted, setTimerHasStarted] = useState(false);

  const { seconds, minutes, restart } = useTimer({
    expiryTimestamp: undefined,
    onExpire: () => {
      // onClick('button')
    },
  });

  useEffect(() => {
    if (!timerHasStarted && typeof data.time === 'number' && data.time > 0) {
      setTimerHasStarted(true);
      restart(data.time * 1000 + Date.now());
    } else if (timerHasStarted && data.time === null) {
      restart(Date.now());
      setTimerHasStarted(false);
    }
  }, [data.time, restart, timerHasStarted]);

  const handleClick = useCallback(() => {
    if (!loading && (isWidgetButton || (!seconds && !minutes))) {
      onClick(data.action);
    }
  }, [data.action, isWidgetButton, loading, minutes, onClick, seconds]);

  const label = useMemo(() => {
    if ((minutes || seconds) && isWidgetButton) {
      return (
        <Fragment>
          {data.label}
          <span>{` ${getTimeTranslation(minutes, seconds, lang)}`}</span>
        </Fragment>
      );
    }

    return data.label;
  }, [data.label, isWidgetButton, lang, minutes, seconds]);

  return (
    <button className={`button_ta ${buttonClassNamesByType[data.type]} ${className}`} onClick={handleClick}>
      {data.type === 'main_dot' && <div className="red-dot_ta" />}
      {loading ? (
        <Spinner size={24} className="button-spinner" color="#429EFF" />
      ) : (
        <div className="button_ta__label">{label}</div>
      )}
    </button>
  );
}

export default Button;
